
import React, { useEffect, useState } from "react";
import axios from '@utils/axios'
import { toast } from 'react-toastify';
import Translate from '../components/translate/conf';
import ReactDOMServer from 'react-dom/server';
import {isValidHost,isValidMask} from '@app/utils/helpers';

export default class LanAddressPage extends React.Component {
  constructor(props) {
    super(props)
    axios({
      url: '/api/systeminfo',
    }).then((response) => {
        this.setState(response.data.data)
    }).catch((err) => console.log(err))
    axios({
      url: '/api/network-interfaces',
    }).then((response) => {
      let newState = {
        options: []
      }
      for( const key in response.data.data ){
        if( key.indexOf("iface") != -1 ){
          const value = response.data.data[key]
          newState.options.push(<option value={value} key={value}>{value}</option>)
        }
      }
      if( newState.options.length > 0 ){
        if( newState.options.length > 1 ){
          newState.displayMgntIface = true
          if( response.data.data['change-olt-network'] == true ){
            newState.displayOltIface = true
          }
        }
        this.setState(newState)
      }
    }).catch((err) => console.log(err))
  }

  state = {
    mgntIpAddr: '',
    mgntIpMask: '',
    mgntIpGateway: '',
    mgntIface:'',
    oltIpAddr: '',
    oltIpMask: '',
    oltIface: '',
    options: [],
    displayMgntIface: false,
    displayOltIface: false,
  }

  handleChangeMgntIp = event => {
    this.setState({
      mgntIpAddr: event.target.value,
    });
  }
  handleChangeMgntIpMask = event => {
    this.setState({
      mgntIpMask: event.target.value,
    });
  }
  handleChangeMgntIpGw = event => {
    this.setState({
      mgntIpGateway: event.target.value,
    });
  }
  handleChangeMgntIface = event => {
    this.setState({
      mgntIface: event.target.value,
    });
  }

  handleChangeOltIp = event => {
    this.setState({
      oltIpAddr: event.target.value,
    });
  }
  handleChangeOltMask = event => {
    this.setState({
      oltIpMask: event.target.value,
    });
  }
  handleChangeOltIface = event => {
    this.setState({
      oltIface: event.target.value,
    });
  }
  
  submitForm(bodyFormData){
    axios({
      method: 'post',
      url: '/api/systeminfo',
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      if ( response.data.err !== undefined && response.data.err === "" ) {
        toast.success(<Translate transVar='ManagementCard.SaveSuccess'/>);
      } else {
        console.log(response.data.err)
        let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
        toast.error(label + response.data.err)
      }
    }).catch((err) => {
      //handle error
      console.log(err)
      let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
      toast.error(label + err)
    });
  }

  handleNetworkMgnt = event => {
    event.preventDefault()

    if( !isValidHost(this.state.mgntIpAddr,<Translate transVar='ManagementCard.LANAddress.IPAddress'/>) || 
        !isValidMask(this.state.mgntIpMask,<Translate transVar='ManagementCard.LANAddress.Netmask'/>)   || 
        !isValidHost(this.state.mgntIpGateway,<Translate transVar='ManagementCard.LANAddress.Gateway'/>) || 
        this.state.mgntIface.length == 0 )
        return;

    this.submitForm({
      mgntIpAddr: this.state.mgntIpAddr,
      mgntIpMask: this.state.mgntIpMask,
      mgntIpGateway: this.state.mgntIpGateway,
      mgntIface: this.state.mgntIface,
    })
  }

  handleNetworkOlt = event => {
    event.preventDefault()

    if( !isValidHost(this.state.oltIpAddr,<Translate transVar='ManagementCard.LANAddress.IPAddress'/>) || 
        !isValidMask(this.state.oltIpMask,<Translate transVar='ManagementCard.LANAddress.Netmask'/>) ||
        this.state.oltIface.length == 0 )
        return;

    this.submitForm({
      oltIpAddr: this.state.oltIpAddr,
      oltIpMask: this.state.oltIpMask,
      oltIface: this.state.oltIface,
    })
  }

  render() {

    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1><Translate transVar='menusidebar.label.ManagementCard.LANAddress' /></h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Translate transVar='menusidebar.label.ManagementCard.Parent' />
                  </li>
                  <li className="breadcrumb-item active">
                    <Translate transVar='menusidebar.label.ManagementCard.LANAddress' />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title"><Translate transVar='ManagementCard.LANAddress.Ethernet'/></h3>
                  </div>
                  <form onSubmit={this.handleNetworkMgnt}>
                    <div className="card-body">
                      <div className="form-group" style={{ display: this.state.displayMgntIface ? 'block' : 'none'}} >
                          <label><Translate transVar='ManagementCard.LANAddress.NetworkInterface' /></label>
                          <select className="custom-select" value={this.state.mgntIface} onChange={this.handleChangeMgntIface} >{this.state.options}</select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="InputMgntIPAddress"><Translate transVar='ManagementCard.LANAddress.IPAddress'/></label>
                        <input type="text" id="InputMgntIPAddress" className="form-control" required value={this.state.mgntIpAddr} onChange={this.handleChangeMgntIp} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="InputMgntIPNetmask"><Translate transVar='ManagementCard.LANAddress.Netmask'/></label>
                        <input type="text" id="InputMgntIPNetmask" className="form-control" required value={this.state.mgntIpMask} onChange={this.handleChangeMgntIpMask} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="InputMgntIPGateway"><Translate transVar='ManagementCard.LANAddress.Gateway'/></label>
                        <input type="text" id="InputMgntIPGateway" className="form-control" required value={this.state.mgntIpGateway} onChange={this.handleChangeMgntIpGw} />
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary"><Translate transVar='Button.Save'/></button>
                    </div>
                  </form>
                </div>
              </div>
              { (localStorage.getItem('showOLTAddress') === "true") &&
                <div className="col-md-4">
                  <div className="card card-primary">
                    <div className="card-header">
                      <h3 className="card-title"><Translate transVar='ManagementCard.LANAddress.OLTHost'/>*</h3>
                    </div>
                    <form onSubmit={this.handleNetworkOlt}>
                      <div className="card-body">
                        <div className="form-group">
                          <strong>* <Translate transVar='ManagementCard.LANAddress.ExplainOLTHost'/></strong>
                        </div>
                        <div className="form-group" style={{ display: this.state.displayOltIface ? 'block' : 'none'}}>
                            <label><Translate transVar='ManagementCard.LANAddress.NetworkInterface' /></label>
                            <select className="custom-select" value={this.state.oltIface} onChange={this.handleChangeOltIface} >{this.state.options}</select>
                        </div>
                        <div className="form-group">
                          <label htmlFor="InputOltIPAddress"><Translate transVar='ManagementCard.LANAddress.IPAddress'/></label>
                          <input type="text" id="InputOltIPAddress" className="form-control" required value={this.state.oltIpAddr} onChange={this.handleChangeOltIp} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="InputOltIPNetmask"><Translate transVar='ManagementCard.LANAddress.Netmask'/></label>
                          <input type="text" id="InputOltIPNetmask" className="form-control" required value={this.state.oltIpMask} onChange={this.handleChangeOltMask} />
                        </div>
                      </div>
                      <div className="card-footer">
                        <button type="submit" className="btn btn-primary"><Translate transVar='Button.Save'/></button>
                      </div>
                    </form>
                  </div>
                </div>
              }
            </div>
          </div>
        </section>
      </>
    )
  }
}
